export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 3_03.a8c17af3.jpg";